module.exports = __webpack_public_path__ + "img/calendar.fd107bb8.png";